import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

// Testimonials data
const testimonialsData = [
  {
    name: 'Sarah J.',
    text: "I thought my fiddle leaf fig was a goner, but ATX Plant Rescue brought it back to life in just a few visits. Highly recommend!",
  },
  {
    name: 'Daniel M.',
    text: "They helped me set up all the greenery in my new office — everything looks amazing and is thriving.",
  },
  {
    name: 'Angela R.',
    text: "I left town for 3 weeks and came back to plants healthier than when I left. Great service!",
  },
];

export default function Testimonials() { // Renamed component
  return (
    <section className="bg-[#CAD3D0] py-4 px-6 text-[#1A3C34]" id='client'> {/* Consistent section styling */}
      <div className="max-w-7xl mx-auto">
        {/* Headline */}
        <div className="text-center mb-6">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold leading-tight">
           Client Love
          </h2>
          <p className="text-base text-gray-600 mt-4 max-w-2xl mx-auto">
            Real stories from real transformations. Hear how personalized coaching with Elizabeth and Nouriv has made a difference.
          </p>
        </div>

        {/* Swiper Testimonials */}
        <div className="max-w-3xl mx-auto px-4 py-4">
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={30}
            slidesPerView={1}
            loop
            autoplay={{ delay: 5000, disableOnInteraction: false }} // disableOnInteraction keeps it auto-playing after user interaction
            pagination={{ clickable: true }}
            className="mySwiper" // Added a class for potential custom styling if needed
          >
            {testimonialsData.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="bg-white p-8 rounded-xl shadow-lg text-center flex flex-col justify-between h-full"> {/* Updated background, padding, shadow, and added flex for content alignment */}
                  <p className="italic text-lg md:text-xl leading-relaxed mb-6 text-gray-700">"{item.text}"</p> {/* Increased text size, leading */}
                  <p className="font-bold text-black text-md md:text-lg"> {/* Stronger font, slightly larger */}
                    — {item.name}
                  </p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
}